import { dynamicResourceLinks } from "./util";
import { useState } from 'react';


const InputPassword = (props) => {
	const [showpassword, setshowpassword] = useState(false);
	return (
		<>
		<div className="inputpasswordcontainer flex-jc-fe flex-ai-cr" style={{width: props?.style?.width, height: props?.style?.height}}>
			<input {...props} className={"inputpassword " + props?.className} style={{...props?.style, width: "100%", height: "100%"}} type={showpassword ? "text" : "password"}/>
			<img className="inputpasswordimg" src={dynamicResourceLinks("ffffff").openEyeIcon} alt="" style={{...(!showpassword && {display: "none"})}} onClick={() => { setshowpassword(!showpassword)}}/>
			<img className="inputpasswordimg" src={dynamicResourceLinks("ffffff").closedEyeIcon} alt="" style={{...(showpassword && {display: "none"})}} onClick={() => { setshowpassword(!showpassword)}}/>
		</div>
		</>
	);
}
 
export default InputPassword;